// extracted by mini-css-extract-plugin
export default {"selectors":"order-form_selectors__uXGBF","selector_row":"order-form_selector_row__ebV8z","row_label":"order-form_row_label__bAzEB"};